import { render, staticRenderFns } from "./QuoteList.vue?vue&type=template&id=520d2161&scoped=true&"
import script from "./QuoteList.vue?vue&type=script&lang=js&"
export * from "./QuoteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520d2161",
  null
  
)

export default component.exports